define.alias("shared/errors/missing-translation", "calendar/errors/missing-translations");